import PropTypes from 'prop-types';

const OrderSummary = ({product}) => {
  const products = Array.isArray(product) ? product : [product];

  const capitalize = str => str?.charAt(0).toUpperCase() + str?.slice(1).toLowerCase();

  return (
    <div>
      {products.map((item, index) => (
        <div key={index} className={'flex items-start mb-4 w-full lg:p-2 shadow-md'}>
          <div className={'flex w-full'}>
            <div className={'w-20 h-20 sm:w-24 sm:h-24 md:w-28 md:h-28 lg:w-20 lg:h-20'}>
              <img
                alt={'product'}
                src={Array.isArray(item.imageUrl) ? item.imageUrl[0] : item.imageUrl}
                className={'w-full h-full object-cover rounded-lg'}
              />
            </div>
            <div className={'ml-4 flex flex-col lg:gap-2 gap-1 w-full'}>
              <div className={'flex lg:flex-row flex-col gap-3 justify-evenly'}>
                <h1 className={'lg:text-base lg:w-1/2 font-semibold'}>{capitalize(item.productName)}</h1>
                <h1 className={'lg:text-base lg:w-1/3 lg:block hidden'}><span className={'font-medium'}>Size: </span>{item.size}</h1>
                <h1 className={'lg:text-base lg:w-1/3 lg:block hidden'}><span className={'font-medium'}>Qty: </span>{item.quantity}</h1>
                <h1 className={'lg:text-base lg:w-1/2'}><span className={'font-bold text-primary-800'}>₹ </span>{item.pricePerUnit}</h1>
              </div>
              <div className={'flex gap-1 justify-between'}>
                <h1 className={'lg:text-base lg:w-1/2 lg:hidden block'}><span className={'font-medium'}>Size: </span>{item.size}</h1>
                <h1 className={'lg:text-base lg:w-1/2 lg:hidden block'}><span className={'font-medium'}>Quantity: </span>{item.quantity}</h1>
              </div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

OrderSummary.propTypes = {
  product: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    image: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]),
    size: PropTypes.string,
    quantity: PropTypes.number,
    productType: PropTypes.string,
    jewelryType: PropTypes.string,
  }).isRequired,
};

export default OrderSummary;
